import * as React from "react";
import type { Article } from "../data";
import { useStyles } from "./ArticleItem.web.styles";

export const ArticleItem: React.FC<{
  article: Article;
}> = ({ article }) => {
  const styles = useStyles();
  return (
    <div key={article.link} className={styles.item}>
      <img
        className={styles.img}
        src={article.imgSrc}
        loading="lazy"
        alt={article.imgAlt}
      />
      <div>
        <h3 className={styles.title}>{article.title}</h3>
        <p>{article.description}</p>
        <p>
          <a
            className={styles.link}
            href={article.link}
            target="_blank"
            rel="noreferrer"
          >
            {article.ctaText}
          </a>
        </p>
      </div>
    </div>
  );
};
